import Banner from '@/components/Banner2';
import Advantages from '@/components/Advantages/index.vue';
import CustomCases from './components/customCases.vue';
import ApplicationScenario from './components/ApplicationScenario.vue';
import Title from '@/components/Title/index.vue';
import Card from '@/components/Card/index.vue';
import Appointment2 from '@/components/Appointment2/index.vue';
export default {
  components: {
    Banner,
    Advantages,
    CustomCases,
    ApplicationScenario,
    Title,
    Card,
    Appointment2
  },
  data() {
    return {
      imageUrl: require('@/assets/images/securitiessolutions/SecuritiesSolutions-banner.png'),
      bannerTitle: '证券解决方案',
      solutionTitle: '方案构成',
      bannerText: '为券商提供从底层技术架构到平台、数据，再到内容、营销、运营、人工智能等系统工具服务，助力金融机构低成本实现产品建设、用户增长及资产提升。',
      caseText: 'They are using the intelligent short video platform to make videos embrace AI',
      adsList: [{
        img: require('@/assets/images/securitiessolutions/securitiesSolutions-grouth.png'),
        title: '丰富的增长经验',
        desc: '将同花顺丰富的用户增长方法论与金融场景相结合，助力金融机构强于获客，胜在运营，快速突破增长瓶颈。'
      }, {
        img: require('@/assets/images/securitiessolutions/securitiesSolutions-full.png'),
        title: '全业务覆盖',
        desc: '基于同花顺对业务的深刻洞察，围绕经济业务、财富管理、投资研究等核心业务场景，提供全业务解决方案。'
      }, {
        img: require('@/assets/images/securitiessolutions/securitiesSolutions-secure.png'),
        title: '技术安全成熟',
        desc: '提供大数据、云计算、人工智能等安全、成熟的金融科技能力，助力金融机构数字化转型。'
      }, {
        img: require('@/assets/images/securitiessolutions/securitiesSolutions-massive.png'),
        title: '海量数据支撑',
        desc: '拥有海量金融数据资源，可满足机构客户投研、交易、风控和估值等各类业务需求，提供稳定、可靠、灵活的数据服务。'
      }],
      solutionsList: [{
        img: require('@/assets/images/securitiessolutions/securitiesSolutions-oem.png'),
        title: '金融终端',
        desc: '提供集行情、交易、理财、资讯、投顾等功能于一体的投资理财平台。'
      }, {
        img: require('@/assets/images/securitiessolutions/securitiesSolutions-bigdata.png'),
        title: '大数据',
        desc: '基于大数据平台，有效整合企业内外部数据信息，为证券公司业务拓展提供数据应用、数据分析、数据洞察决策等敏捷支撑。'
      }, {
        img: require('@/assets/images/securitiessolutions/securitiesSolutions-op.png'),
        title: '运营中台',
        desc: '提供包含产品配置、商城管理、订单管理、广告配置、优惠券系统、活动运营等功能支持，高效赋能券商展业获客。'
      }, {
        img: require('@/assets/images/securitiessolutions/securitiesSolutions-welth.png'),
        title: '财富管理',
        desc: '将客户需求、资产状况、产品信息和投顾服务、交易服务、增值服务等整合起来，为客户提供千人千面的财富管理服务，帮助金融机构建立全面的财富管理能力。'
      }, {
        img: require('@/assets/images/securitiessolutions/securitiesSolutions-aiapp.png'),
        title: 'AI应用',
        desc: '打造了基于AI能力的智慧服务生态，以金融科技驱动证券业务升级转型'
      }, {
        img: require('@/assets/images/securitiessolutions/securitiesSolutions-finialData.png'),
        title: '金融数据',
        desc: ' 基于海量金融数据，提供数据库、数据接口等标准化产品，支持个性化定制，充分满足金融机构员工多样化的数据需求'
      }],
      cardWidth: '630px'
    };
  }
};